import React, {useEffect, useState} from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {
    Typography,
    Card,
    CardActions,
    CardContent,
    Button,
    TextField,
} from "@material-ui/core";
import API from "../../../helpers/apiHelpers";
import { useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
// import * as yup from "yup";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useSelector, useDispatch} from "react-redux";
import {getUserProfile, patchUserProfile, addAddress, getAddress} from "../../../redux/userProfile/userProfile.actions";
import MuiPhoneNumber from "material-ui-phone-number";
import { useSnackbar } from "notistack";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

//NEED TO ADD DOB

interface Props {
    data: any,
    isFinished: boolean | null;
    isMobile: boolean;
    setIsFinished: React.Dispatch<any>;
}

const useStyle = makeStyles((theme: Theme) => createStyles({
    topSpacing: {
        paddingTop: "20px",
    },
    root: {
        display: "flex",
        width: "90%",
        marginTop: 20,
        alignSelf: "center",
    },
    details: {
        display: "flex",
        flexDirection: "column",
        marginLeft: 10,
        width: "100%"
    },
    content: {
        flex: "auto",
        width: "100%"
    },
    appointmentInfo: {
        width: "100%",
        paddingBottom: 10
    },
}));

const PersonEdit = ({data, isFinished, isMobile, setIsFinished}: Props) => {
    const [user, setUser] = useState<undefined | any>();
    const [adjustPerson, setAdjustPerson] = useState(false);
    const classes = useStyle();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const appointmentData = useSelector((state: RootState) => state?.appointment.appointment);
    const [result, setResult] = useState(null);
    const [existingNoteId, setExistingNoteId] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [profileId, setProfileId] = useState(0);
    const [birthday, setBirthday] = useState("");
    const [birthdate, setBirthdate] = useState<null | moment.Moment>(null);
    const [addressId, setAddressId] = useState(0);
    const [type, setType] = useState("");
    const [personState, setPersonState] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        // email: "",
        zip: "",
        state: "",
        city: "",
        address: "",
        country: "",
    });

    const requestAppointment = async () => {
        // eslint-disable-next-line no-prototype-builtins
        appointmentData.hasOwnProperty("finished") ? setIsFinished(appointmentData.finished) : setIsFinished(false);
    };

    useEffect(() => {
        (async () => {
            try {
                const resp = await API.getProfiles({userId: data.data.item.clientUserId}).then(response => {
                    setUser(response[0]);
                    setProfileId(response[0].id);
                    setType(response[0].type);
                    return response;
                });
                const addressData = await API.getAddressAppointment(data.data.item.clientUserId);
                if (addressData.length){
                    let currentAddress = addressData.filter(item => item.defaultAddress === true)[0];
                    setAddressId(currentAddress.id);
                    setPersonState({
                        firstName: resp[0].firstName,
                        lastName: resp[0].lastName,
                        phoneNumber: resp[0].phoneNumber,
                        zip: currentAddress.zipCode,
                        state: currentAddress.state,
                        city: currentAddress.city,
                        address: currentAddress.firstLine,
                        country: currentAddress?.country || "United States of America",
                    });
                    setBirthday(resp[0].birthday || "");
                    setBirthdate(moment(resp[0].birthday) || moment());
                }else{
                    try {
                        setAddressId(addressData?.id);
                        setPersonState({
                            firstName: resp[0].firstName,
                            lastName: resp[0].lastName,
                            phoneNumber: resp[0].phoneNumber,
                            zip: addressData?.zipCode,
                            state: addressData?.state,
                            city: addressData?.city,
                            address: addressData?.firstLine,
                            country: addressData?.country || "United States of America",
                        });
                        setBirthday(resp[0].birthday || "");
                        setBirthdate(moment(resp[0].birthday) || moment());
                    }finally{
                        console.log("Finished");
                    }
                }
            } catch (err) {
                console.error(err);
            }
        })();
        requestAppointment();
    }, []);

    //Form Hooks:
    const personFormik = useFormik({
        initialValues: personState,
        enableReinitialize: true,
        onSubmit: async (values) => {
            await API.patchAddress(addressId,{
                zipCode: values.zip,
                state: values.state.toUpperCase(),
                city: values.city,
                firstLine: values.address,
                country: values.country,
                defaultAddress: true,
            });
            setAdjustPerson(false);
            const body={
                firstName: values.firstName,
                lastName: values.lastName,
                phoneNumber: values.phoneNumber,
                practiceCode: "01",
                userId: data.data.item.clientUserId,
                type: type,
                locationTimeZone: moment.tz.guess()
            };
            if (birthday !== null) {body["birthday"] = birthday;}
            await dispatch(patchUserProfile({id: profileId, body}));
            setAdjustPerson(false);
        }
    });


    return(
        <Grid container justify="center" alignItems="center" className={classes.topSpacing}>
            <Card className={classes.root}>
                {adjustPerson ? (
                    <form className={classes.details} onSubmit={personFormik.handleSubmit}>
                        <CardContent className={classes.content}>
                            <Grid container spacing={1} justify="center" alignItems="center" className={classes.appointmentInfo}>
                                <Grid item xs={12}>
                                    <Typography variant="h4">{personState.firstName} {personState.lastName}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <MuiPhoneNumber
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        defaultCountry={"us"}
                                        onlyCountries={["us"]}
                                        onChange={(value) => personFormik.setFieldValue("phoneNumber", value)}
                                        value={personFormik.values.phoneNumber}
                                        disableCountryCode={true}
                                        label="Phone Number"
                                        aria-labelledby="Phone Number"
                                        fullWidth={true}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <DatePicker
                                            autoOk
                                            disableFuture={true}
                                            label="Date of Birth"
                                            aria-labelledby="Date of Birth"
                                            fullWidth
                                            format="MMM dd, yyyy"
                                            openTo="date"
                                            value={birthdate}
                                            onChange={(value) => {
                                                setBirthdate(moment(value));
                                                setBirthday(moment(value).format("YYYY-MM-DD"));
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={personFormik.values.address}
                                        onChange={personFormik.handleChange}
                                        label="Address"
                                        id="address"
                                        name="address"
                                        style={{width: "100%", marginBottom: 10}}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={personFormik.values.city}
                                        onChange={personFormik.handleChange}
                                        label="City"
                                        id="city"
                                        name="city"
                                        aria-labelledby="city"
                                        style={{width: "100%", marginBottom: 10}}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={personFormik.values.state}
                                        onChange={personFormik.handleChange}
                                        label="State / Territory (Abbreviated)"
                                        id="state"
                                        name="state"
                                        aria-labelledby="state"
                                        style={{width: "100%", marginBottom: 10}}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        value={personFormik.values.zip}
                                        onChange={personFormik.handleChange}
                                        label="Zip Code"
                                        id="zip"
                                        name="zip"
                                        aria-labelledby="zipcode"
                                        style={{width: "100%", marginBottom: 10}}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                type="submit"
                            >
                                Save Details
                            </Button>
                        </CardActions>
                    </form>
                ) : (
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Grid container className={classes.appointmentInfo}>
                                <Grid item xs={6}>
                                    <Typography variant="h4">{typeof user !== "undefined" ? `${user.firstName} ${user.lastName}` : null}</Typography>
                                </Grid>
                            </Grid>
                            <Grid container justify={isMobile? "flex-start" : "space-between"} alignItems="center">
                                <Grid item xs={12} sm={10}>
                                    <Typography variant="body2">
										Phone: <span style={{fontWeight: 400}}>{personFormik.values.phoneNumber}</span>
                                    </Typography>
                                    <Typography variant="body2">
										DOB: <span style={{fontWeight: 400}}>{birthdate ? birthdate.format("MMM DD, YYYY") : ""}</span>
                                    </Typography>
                                    <Typography variant="body2">
											Address: <span style={{fontWeight: 400}}>{personFormik.values.address}</span>
                                    </Typography>
                                    <Typography variant="body2">
											City/State/Zip: <span style={{fontWeight: 400}}>{personFormik.values.city}, {personFormik.values.state} {personFormik.values.zip}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                        <CardActions>
                            <Button
                                type="button"
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={() => setAdjustPerson(true)}
                            >
                                Edit Details
                            </Button>
                        </CardActions>
                    </div>
                )}
            </Card>
        </Grid>
    );
};

export default PersonEdit;
